export { default } from './menu-section-heading';
